export default class BookAppliedBookingRoleWorkerRequest
 {
    payRate: number;
    chargeRate: number;
    bookingRoleWorkerShiftIds: string[];
}